var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apexchart',{attrs:{"type":"bar","height":_vm.$vuetify.breakpoint.smAndDown ? '100%' : 380,"options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }